/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import config from './config.json';
import { defaultItem, menu } from './menu';
import routes from './routes';
import scopes from './scopes';

const api = {
  url: `${process.env.REACT_APP_API_URL}/api/v1`,
  auth: 'https://auth.cpl.cloud',
};

export { api, defaultItem, menu, scopes, routes, config };
